import { useEffect, useState } from 'react';
import { Card, Empty, Page, Spinner, api, dateTime } from '@mobi/web';

interface Entry {
  id: number;
  action: string;
  target_type: string;
  target_id: number;
  detail: string | null;
  ip: string;
  created_at: string;
  admin_name: string;
}

export function Audit() {
  const [entries, setEntries] = useState<Entry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void (async () => {
      try {
        setEntries((await api<{ entries: Entry[] }>('/api/admin/audit?limit=200')).entries);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Page title="Auditoria" subtitle="Toda ação de admin que mexe em dinheiro ou dados de terceiros.">
      {loading ? (
        <div className="grid place-items-center py-16"><Spinner /></div>
      ) : entries.length === 0 ? (
        <Empty title="Nada registrado ainda" />
      ) : (
        <Card className="divide-y divide-line p-0">
          {entries.map((e) => (
            <div key={e.id} className="px-5 py-3 text-sm">
              <p className="font-medium">
                {e.admin_name} · {e.action} · {e.target_type} #{e.target_id}
              </p>
              <p className="text-faint">
                {dateTime(e.created_at)} · {e.ip}
                {e.detail && ` · ${e.detail}`}
              </p>
            </div>
          ))}
        </Card>
      )}
    </Page>
  );
}
